export default {"src":"/_next/static/media/location-target-icon.620a212d.svg","height":16,"width":16};